export async function processBlocks(data, blockTemplate, callback) {
  const blocksContainer = data.blocks || {};

  for (let key in blocksContainer) {
    if (!blocksContainer.hasOwnProperty(key)) continue;
    const blocks = blocksContainer[key] || [];
    for (let block of blocks) {
      if (block.template != blockTemplate) continue;
      await callback(block);
    }
  }
}
